import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarPrecertificacionUrl = (request) =>
  `api/v1/websalud/primeraars/precertificaciones/${request.numeroPrecertificacion}`;

const confirmarPrecertificacionUrl = (request) =>
  `api/v1/websalud/primeraars/precertificaciones/${request.numeroPrecertificacion}/confirmacion?compania=${request.compania}`;

const cancelarPrecertificacionUrl = (request) =>
  `api/v1/websalud/primeraars/precertificaciones/${request.numeroPrecertificacion}/cancelacion?compania=${request.compania}`;

const consultarPrecertificacion = (request) =>
  InterceptToken(
    BaseApi.get,
    consultarPrecertificacionUrl(request.requestData),
    { compania: request?.requestData?.compania },
    request.requestHeaders
  ).then((response) => response.data);

const confirmarPrecertificacion = (request) =>
  InterceptToken(
    BaseApi.post,
    confirmarPrecertificacionUrl(request.requestData),
    { compania: request?.requestData?.compania },
    request.requestHeaders
  ).then((response) => response.data);

const cancelarPrecertificacion = (request) =>
  InterceptToken(
    BaseApi.post,
    cancelarPrecertificacionUrl(request.requestData),
    { compania: request?.requestData?.compania },
    request.requestHeaders
  ).then((response) => response.data);

const exportedObject = {
  consultarPrecertificacion,
  confirmarPrecertificacion,
  cancelarPrecertificacion,
};

export default exportedObject;
